import default_ from "./default.json" with { type: "json" };
import advancedRuleTexts from "./advancedRuleTexts.json" with { type: "json" };
import deviceCategories from "./deviceCategories.json" with { type: "json" };
import deviceTypes from "./deviceTypes.json" with { type: "json" };
import historyMessages from "./historyMessages.json" with { type: "json" };
import matter from "./matter.json" with { type: "json" };
import pairingCategories from "./pairingCategories.json" with { type: "json" };
import pairingDeviceCategories from "./pairingDeviceCategories.json" with { type: "json" };
import pairingDevices from "./pairingDevices.json" with { type: "json" };
import preLoginPages from "./preLoginPages.json" with { type: "json" };
import roomTemplateLabels from "./roomTemplateLabels.json" with { type: "json" };
import ruleCategories from "./ruleCategories.json" with { type: "json" };
import services from "./services.json" with { type: "json" };
import smartWidgetsCategories from "./smartWidgetsCategories.json" with { type: "json" };
import templateRuleTexts from "./templateRuleTexts.json" with { type: "json" };
import zWaveNotifications from "./zWaveNotifications.json" with { type: "json" };

export default {
	...default_,
	advancedRuleTexts,
	deviceCategories,
	deviceTypes,
	historyMessages,
	matter,
	pairingCategories,
	pairingDeviceCategories,
	pairingDevices,
	preLoginPages,
	roomTemplateLabels,
	ruleCategories,
	services,
	smartWidgetsCategories,
	templateRuleTexts,
	zWaveNotifications,
} as const;
